const GET_PROFILE_GUESTBOOK_REQUEST = 'GET_PROFILE_GUESTBOOK_REQUEST';
const GET_PROFILE_GUESTBOOK_SUCCESS = 'GET_PROFILE_GUESTBOOK_SUCCESS';
const GET_PROFILE_GUESTBOOK_FAILURE = 'GET_PROFILE_GUESTBOOK_FAILURE';

import {
    MEMBER_GUESTBOOK_DELETE_MESSAGE_SUCCESS,
    MEMBER_GUESTBOOK_MESSAGE_ADDED
} from './member';

import * as backend from 'backend-helpers/profileGuestbook';
import {BobTVUser} from 'bobtvuser';

const initState = {
    user: null,
    blacklistedMe: null,
    online: null,
    guestbookMessages: {
        isLoading: false,
        list: [],
        totalCount: undefined,
        offset: undefined
    }
};

export default function profileGuestbook(state = initState, action) {
    if (action.type === GET_PROFILE_GUESTBOOK_REQUEST) {
        return {
            ...state,
            guestbookMessages: {
                ...state.guestbookMessages,
                isLoading: true
            }
        }
    }

    if (action.type === GET_PROFILE_GUESTBOOK_SUCCESS) {
        let {status, user, guestbookMessages, ...rest} = action.result;
        let {offset} = action;

        return {
            ...state,
            ...rest,
            user: new BobTVUser(user),
            guestbookMessages: {
                ...guestbookMessages,
                list: offset ? [...state.guestbookMessages.list, ...guestbookMessages.list] : guestbookMessages.list,
                isLoading: false
            }
        }
    }

    if (action.type === GET_PROFILE_GUESTBOOK_FAILURE) {
        let {error, ...rest} = action;

        console.log('GET_PROFILE_GUESTBOOK_FAILURE:', error);

        return {
            ...state,
            user: new BobTVUser({_loaded: false, _notFound: true})
        }
    }

    if (action.type === MEMBER_GUESTBOOK_MESSAGE_ADDED && state.user && action.user.id === state.user.id) {
        let list = state.guestbookMessages.list;

        list.pop();
        list = [action.guestbookMessage, ...list];

        return {
            ...state,
            guestbookMessages: {
                ...state.guestbookMessages,
                totalCount: state.guestbookMessages.totalCount+1,
                list
            }
        }
    }

    if (action.type === MEMBER_GUESTBOOK_DELETE_MESSAGE_SUCCESS) {
        let guestbookMessagesList = state.guestbookMessages.list.filter((item) => item.id !== action.id),
            profileGuestbookChanged = (state.guestbookMessages.list.length > 0 && guestbookMessagesList.length != state.guestbookMessages.list.length);

        if (profileGuestbookChanged) {
            return {
                ...state,
                guestbookMessages: {
                    list: guestbookMessagesList,
                    totalCount: state.guestbookMessages.totalCount - 1
                }
            }
        }
    }

    return state;
}

export function getProfileGuestbook(nick, offset = 0) {
    return {
        types: [GET_PROFILE_GUESTBOOK_REQUEST, GET_PROFILE_GUESTBOOK_SUCCESS, GET_PROFILE_GUESTBOOK_FAILURE],
        promise: backend.getProfileGuestbook(nick, offset),
        offset: offset
    }
}


// WEBPACK FOOTER //
// ./src/reducers/profileGuestbook.js